/* eslint-disable max-len */
import {API_ENDPOINT_JSON} from '../../../../../config';
import {
  conditionType,
  inputType
} from '../../../../../pages/esgManager/interface/inputType';
import {
  ENVIRONMENTAL_ISSUE_OPTIONS,
  INITIATIVE_ID_OPTIONS
} from '../SME/smeQuestions';

import {
  ACTION_DRIVEN_BY_SUPPLIER_ENGAGEMENT_OPTIONS,
  ASSESSMENT_OF_SUPPLIER_DEPENDENCIES_AND_OR_IMPACTS_ON_THE_ENVIRONMENT_OPTIONS,
  BUSINESS_DECISIONMAKING_PROCESSES_THE_INTERNAL_PRICE_IS_APPLIED_TO_OPTIONS,
  COMMODITY_OPTIONS,
  CRITERIA_INFORMING_WHICH_SUPPLIERS_ARE_PRIORITIZED_FOR_ENGAGEMENT_ON_THIS_ENVIRONMENTAL_ISSUE_OPTIONS,
  DRIVING_FORCES_IN_SCENARIO_OPTIONS,
  ECONOMIC_ACTIVITY_OPTIONS,
  ENVIRONMENTAL_REQUIREMENT_OPTIONS,
  EXPECTED_BENEFITS_OPTIONS,
  FACTORS_CONSIDERED_WHEN_DETERMINING_THE_PRICE_OPTIONS,
  INITIATIVE_CATEGORY_AND_TYPE_OPTIONS,
  ISSUES_SUPPORTED_IN_SHAREHOLDER_RESOLUTIONS_OPTIONS,
  MECHANISMS_FOR_MONITORING_COMPLIANCE_WITH_THIS_ENVIRONMENTAL_REQUIREMENT_OPTIONS,
  OBJECTIVES_FOR_IMPLEMENTING_INTERNAL_PRICE_OPTIONS,
  PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
  PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS,
  PROCESS_PLACE_OPTIONS,
  Q5_5_1_OPTIONS,
  Q5_5_2_OPTIONS,
  Q5_5_3_OPTIONS,
  Q5_5_4_OPTIONS,
  Q5_5_5_OPTIONS,
  Q5_5_6_OPTIONS,
  ROLES_OF_INDIVIDUALS_AT_THE_PORTFOLIO_ORGANIZATIONS_YOU_SEEK_TO_ENGAGE_WITH_OPTIONS,
  SCENARIO_TRANSTION_SCENARIO_OPTIONS,
  SCOPES_COVERED_OPTIONS,
  STAFF_IN_YOUR_ORGANIZATION_CARRYING_OUT_THE_ENGAGEMENT_OPTIONS,
  SUPPLIER_TIER_OPTIONS,
  TECHNOLOGY_AREA_OPTIONS,
  TECHNOLOGY_AREAS_OPTIONS,
  TYPE_AND_DETAILS_OF_ENGAGEMENT_EDUCATION_OPTIONS,
  TYPE_AND_DETAILS_OF_ENGAGEMENT_OPTIONS,
  TYPE_OF_PRICING_SCHEME_OPTIONS
} from './corporateOptions';
import {CDP_CORPORATE_STRATEGY_FIELD_NAMES} from './corporateQuestionsKeys';

export const corporateBusinessStrategyQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.1 Does your organization use scenario analysis to identify environmental outcomes?',
            tooltip:
              'Scenario analysis is considered a valuable tool to inform an organization’s business strategy as part of transitioning to a sustainable economy. This question establishes whether your organization uses scenario analysis to identify environment-related outcomes, which is a recommended practice for businesses preparing for possible futures.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_1_VALUE,
                  fieldLabel: 'Environmental issue',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE,
                  fieldLabel: 'Use of scenario analysis',
                  options: PROCESS_PLACE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_3_VALUE,
                  fieldLabel: 'Frequency of analysis',
                  options: [
                    {
                      value: 'More than once a year',
                      label: 'More than once a year'
                    },
                    {value: 'Annually', label: 'Annually'},
                    {value: 'Every two years', label: 'Every two years'},
                    {
                      value: 'Every three years or more',
                      label: 'Every three years or more'
                    },
                    {
                      value: 'As important matters arise',
                      label: 'As important matters arise'
                    },
                    {value: 'Not defined', label: 'Not defined'},
                    {
                      value: 'First time carrying out analysis',
                      label: 'First time carrying out analysis'
                    },
                    {
                      value: 'On a per project basis',
                      label: 'On a per project basis'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_4_VALUE,
                  fieldLabel:
                    'Primary reason why your organization has not used scenario analysis',
                  options: [
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Lack of available methodologies',
                      label: 'Lack of available methodologies'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {value: 'Insufficient data', label: 'Insufficient data'},
                    {
                      value: 'Judged to be unimportant or not relevant',
                      label: 'Judged to be unimportant or not relevant'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, but we plan to within the next two years',
                      'No, and we do not plan to within the next two years'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_5_VALUE,
                  fieldLabel:
                    'Explain why your organization has not used scenario analysis',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, but we plan to within the next two years',
                      'No, and we do not plan to within the next two years'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.1.1 Provide details of the scenarios used in your organization’s scenario analysis.',
            tooltip:
              'Scenario analysis is considered a valuable tool to inform an organization’s business strategy as part of transitioning to a sustainable economy. Your response to this question provides data users with an indication of the extent to which your organization is considering a range of possible and probable futures when considering environmental challenges and opportunities in your business strategy.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_1_VALUE,
                  fieldLabel:
                    'Environmental issue this scenario has been used to analyze',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_2_VALUE,
                  fieldLabel: 'Scenario used',
                  options: SCENARIO_TRANSTION_SCENARIO_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_3_VALUE,
                  fieldLabel:
                    'SSP used SSPs used in  conjunction with scenario',
                  options: [
                    {value: 'SSP1', label: 'SSP1'},
                    {value: 'SSP2', label: 'SSP2'},
                    {value: 'SSP3', label: 'SSP3'},
                    {value: 'SSP4', label: 'SSP4'},
                    {value: 'SSP5', label: 'SSP5'},
                    {value: 'No SSP used', label: 'No SSP used'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'RCP 1.9',
                      'RCP 2.6',
                      'RCP 3.4',
                      'RCP 4.5',
                      'RCP 6.0',
                      'RCP 7.0',
                      'RCP 8.5'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_4_VALUE,
                  fieldLabel: 'Approach to scenario',
                  options: [
                    {value: 'Qualitative only', label: 'Qualitative only'},
                    {value: 'Quantitative only', label: 'Quantitative only'},
                    {
                      value: 'Qualitative and quantitative',
                      label: 'Qualitative and quantitative'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_5_VALUE,
                  fieldLabel: 'Scenario coverage',
                  options: [
                    {value: 'Organizationwide', label: 'Organizationwide'},
                    {
                      value: 'Organizationwide excluding portfolio [FS only]',
                      label: 'Organizationwide excluding portfolio [FS only]'
                    },
                    {value: 'Business division', label: 'Business division'},
                    {value: 'Business activity', label: 'Business activity'},
                    {value: 'Facility', label: 'Facility'},
                    {value: 'Country/area', label: 'Country/area'},
                    {value: 'Product-level', label: 'Product-level'},
                    {
                      value: 'Portfolio [FS only]',
                      label: 'Portfolio [FS only]'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_6_VALUE,
                  fieldLabel: 'Risk types considered in scenario',
                  options: [
                    {value: 'Acute physical', label: 'Acute physical'},
                    {value: 'Chronic physical', label: 'Chronic physical'},
                    {value: 'Liability', label: 'Liability'},
                    {value: 'Market', label: 'Market'},
                    {value: 'Policy', label: 'Policy'},
                    {value: 'Reputation', label: 'Reputation'},
                    {value: 'Technology', label: 'Technology'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_7_VALUE,
                  fieldLabel: 'Temperature alignment of scenario',
                  options: [
                    {value: '1.5°C or lower', label: '1.5°C or lower'},
                    {value: '1.6ºC - 1.9ºC', label: '1.6ºC - 1.9ºC'},
                    {value: '2.0ºC - 2.4ºC', label: '2.0ºC - 2.4ºC'},
                    {value: '2.5ºC - 2.9ºC', label: '2.5ºC - 2.9ºC'},
                    {value: '3.0ºC -3.4ºC', label: '3.0ºC -3.4ºC'},
                    {value: '3.5ºC - 3.9ºC', label: '3.5ºC - 3.9ºC'},
                    {value: '4.0ºC and above', label: '4.0ºC and above'},
                    {value: 'Unknown', label: 'Unknown'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_8_VALUE,
                  fieldLabel: 'Reference year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_9_VALUE,
                  fieldLabel: 'Timeframes covered',
                  options: [
                    {value: '2025', label: '2025'},
                    {value: '2030', label: '2030'},
                    {value: '2040', label: '2040'},
                    {value: '2050', label: '2050'},
                    {value: '2060', label: '2060'},
                    {value: '2070', label: '2070'},
                    {value: '2080', label: '2080'},
                    {value: '2090', label: '2090'},
                    {value: '2100', label: '2100'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_10_VALUE,
                  fieldLabel: 'Driving forces in scenario',
                  options: DRIVING_FORCES_IN_SCENARIO_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_11_VALUE,
                  fieldLabel:
                    'Assumptions, uncertainties and constraints in scenario',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q2_12_VALUE,
                  fieldLabel: 'Rationale for choice of scenario',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.1.2 Provide details of the outcomes of your organization’s scenario analysis.',
            tooltip:
              'Data users are interested to know how the outcomes of your scenario analysis have influenced your corporate business strategy and financial planning, as well as the identification, assessment, and management of risks and opportunities. They are also looking to understand how resilient your strategy and business model are in your reported scenarios.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q3_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q3_1_VALUE,
                  fieldLabel: 'Environmental issue',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q3_2_VALUE,
                  fieldLabel:
                    'Business processes influenced by your analysis of the reported scenarios .',
                  options: [
                    {
                      value:
                        'Risk and opportunities identification, assessment and management',
                      label:
                        'Risk and opportunities identification, assessment and management'
                    },
                    {
                      value: 'Strategy and financial planning',
                      label: 'Strategy and financial planning'
                    },
                    {
                      value: 'Resilience of business model and strategy',
                      label: 'Resilience of business model and strategy'
                    },
                    {value: 'Capacity building', label: 'Capacity building'},
                    {
                      value: 'Target setting and transition planning',
                      label: 'Target setting and transition planning'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    },
                    {
                      value:
                        'Scenario analysis has not influenced our business processes',
                      label:
                        'Scenario analysis has not influenced our business processes'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q3_3_VALUE,
                  fieldLabel: 'Coverage of analysis',
                  options: [
                    {value: 'Organizationwide', label: 'Organizationwide'},
                    {
                      value: 'Organizationwide excluding portfolio [FS only]',
                      label: 'Organizationwide excluding portfolio [FS only]'
                    },
                    {value: 'Business division', label: 'Business division'},
                    {value: 'Business activity', label: 'Business activity'},
                    {value: 'Facility', label: 'Facility'},
                    {value: 'Country/area', label: 'Country/area'},
                    {value: 'Product-level', label: 'Product-level'},
                    {
                      value: 'Portfolio [FS only]',
                      label: 'Portfolio [FS only]'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q3_2_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Scenario analysis has not influenced our business processes'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q3_4_VALUE,
                  fieldLabel:
                    'Summarize the outcomes of the scenario analysis and any implications for other environmental issues',
                  colSpan: true,
                  textLimit: 5000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q3_2_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Scenario analysis has not influenced our business processes'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },

      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.2 Does your organization’s strategy include a climate transition plan?',
            tooltip:
              'Developing a climate transition plan provides certainty to data users that an organization is aligning to the long-term, global climate goals and that its business model will continue to be relevant in a net-zero carbon economy. Collecting feedback on the climate transition plan allows shareholders to review and raise resolutions related to progress. This question provides transparency regarding an organization’s transition plans and associated feedback mechanisms.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                  fieldLabel: 'Transition plan',
                  options: [
                    {
                      value:
                        'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      label:
                        'Yes, we have a climate transition plan which aligns with a 1.5°C world'
                    },
                    {
                      value:
                        'Yes, but we have a climate transition plan with a different temperature alignment',
                      label:
                        'Yes, but we have a climate transition plan with a different temperature alignment'
                    },
                    {
                      value:
                        'No, but we are developing a climate transition plan within the next two years',
                      label:
                        'No, but we are developing a climate transition plan within the next two years'
                    },
                    {
                      value:
                        'No, and we do not plan to develop a climate transition plan within the next two years',
                      label:
                        'No, and we do not plan to develop a climate transition plan within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_2_VALUE,
                  fieldLabel: 'Temperature alignment of transition plan',
                  options: [
                    {
                      value: 'Well-below 2°C aligned',
                      label: 'Well-below 2°C aligned'
                    },
                    {value: '2°C aligned', label: '2°C aligned'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_3_VALUE,
                  fieldLabel: 'Publicly available climate transition plan',
                  options: ['Yes', 'No'],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_4_VALUE,
                  fieldLabel:
                    'Plan explicitly commits to cease all spending on, and revenue generation from, activities that contribute to fossil fuel expansion',
                  options: [
                    {value: 'Yes', label: 'Yes'},
                    {
                      value:
                        'No, but we plan to add an explicit commitment within the next two years',
                      label:
                        'No, but we plan to add an explicit commitment within the next two years'
                    },
                    {
                      value:
                        'No, and we do not plan to develop a climate transition plan within the next two years',
                      label:
                        'No, and we do not plan to develop a climate transition plan within the next two years'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_5_VALUE,
                  fieldLabel:
                    'Description of activities included in commitment and implementation of commitment',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_6_VALUE,
                  fieldLabel:
                    'Explain why your organization does not explicitly commit to cease all spending  on and revenue generation from activities that contribute to fossil fuel expansion',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_7_VALUE,
                  fieldLabel:
                    'Mechanism by which feedback is collected from shareholders on your climate transition plan',
                  options: [
                    {
                      value:
                        'Our climate transition plan is voted on at Annual General Meetings (AGMs)',
                      label:
                        'Our climate transition plan is voted on at Annual General Meetings (AGMs)'
                    },
                    {
                      value:
                        'Our climate transition plan is voted on at AGMs and we also have an additional feedback mechanism in place',
                      label:
                        'Our climate transition plan is voted on at AGMs and we also have an additional feedback mechanism in place'
                    },
                    {
                      value: 'We have a different feedback mechanism in place',
                      label: 'We have a different feedback mechanism in place'
                    },
                    {
                      value:
                        'We do not have a feedback mechanism in place, but we plan to introduce one within the next two years',
                      label:
                        'We do not have a feedback mechanism in place, but we plan to introduce one within the next two years'
                    },
                    {
                      value:
                        'We do not have a feedback mechanism in place, and we do not plan to introduce one within the next two years',
                      label:
                        'We do not have a feedback mechanism in place, and we do not plan to introduce one within the next two years'
                    },
                    {
                      value:
                        'Not applicable as our organization does not have shareholders',
                      label:
                        'Not applicable as our organization does not have shareholders'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_8_VALUE,
                  fieldLabel: 'Description of feedback mechanism',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_7_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'We have a different feedback mechanism in place',
                      'Our climate transition plan is voted on at AGMs and we also have an additional feedback mechanism in place',
                      'Not applicable as our organization does not have shareholders'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_9_VALUE,
                  fieldLabel: 'Frequency of feedback collection',
                  options: [
                    {
                      value: 'More frequently than annually',
                      label: 'More frequently than annually'
                    },
                    {value: 'Annually', label: 'Annually'},
                    {
                      value: 'Less frequently than annually',
                      label: 'Less frequently than annually'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_7_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'We have a different feedback mechanism in place',
                      'Our climate transition plan is voted on at AGMs and we also have an additional feedback mechanism in place'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_10_VALUE,
                  fieldLabel:
                    'Description of key assumptions and dependencies on which the transition plan relies',
                  colSpan: true,
                  textLimit: 2000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_11_VALUE,
                  fieldLabel:
                    'Description of progress against transition plan disclosed in current or previous reporting period',
                  colSpan: true,
                  textLimit: 3000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_12_VALUE,
                  fieldLabel:
                    'Attach any relevant documents which detail your climate transition plan',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .businessStrategy,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_13_VALUE,
                  fieldLabel:
                    'Other environmental issues that your climate transition plan considers',
                  options: [
                    {value: 'Forests', label: 'Forests'},
                    {value: 'Plastics', label: 'Plastics'},
                    {value: 'Water', label: 'Water'},
                    {value: 'Biodiversity', label: 'Biodiversity'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    },
                    {
                      value: 'No other environmental issue considered',
                      label: 'No other environmental issue considered'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, we have a climate transition plan which aligns with a 1.5°C world',
                      'Yes, but we have a climate transition plan with a different temperature alignment'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_14_VALUE,
                  fieldLabel:
                    'Explain how the other environmental issues are considered in your climate transition plan',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_15_VALUE,
                  fieldLabel:
                    'Primary reason for not having a climate transition plan that aligns with a 1.5°C world',
                  options:
                    PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, but we are developing a climate transition plan within the next two years',
                      'No, and we do not plan to develop a climate transition plan within the next two years'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_16_VALUE,
                  fieldLabel:
                    'Explain why your organization does not have a climate transition plan that aligns with a 1.5°C world',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q4_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, but we are developing a climate transition plan within the next two years',
                      'No, and we do not plan to develop a climate transition plan within the next two years'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.3 Have environmental risks and opportunities affected your strategy and/or financial planning?',
            tooltip:
              'This question allows organizations to indicate whether they have considered and acted upon their substantive environmental risks and opportunities at a strategic level for the business, rather than solely at the operational level. '
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE,
                  fieldLabel:
                    'Environmental risks and opportunities have affected your strategy and/or financial planning',
                  options: [
                    {value: 'Yes, strategy only', label: 'Yes, strategy only'},
                    {
                      value: 'Yes, financial planning only',
                      label: 'Yes, financial planning only'
                    },
                    {
                      value: 'Yes, both strategy and financial planning',
                      label: 'Yes, both strategy and financial planning'
                    },
                    {
                      value:
                        'We have not evaluated whether environmental risks and opportunities have affected our strategy and financial planning, but plan to do so within the next two years',
                      label:
                        'We have not evaluated whether environmental risks and opportunities have affected our strategy and financial planning, but plan to do so within the next two years'
                    },
                    {
                      value:
                        'We have not evaluated whether environmental risks and opportunities have affected our strategy and financial planning, and do not plan to do so within the next two years',
                      label:
                        'We have not evaluated whether environmental risks and opportunities have affected our strategy and financial planning, and do not plan to do so within the next two years'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_2_VALUE,
                  fieldLabel:
                    'Business areas where environmental risks and/or opportunities have affected your strategy .',
                  options: [
                    {
                      value: 'Products and services',
                      label: 'Products and services'
                    },
                    {
                      value: 'Upstream/downstream value chain',
                      label: 'Upstream/downstream value chain'
                    },
                    {value: 'Investment in R&D', label: 'Investment in R&D'},
                    {value: 'Operations', label: 'Operations'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, strategy only',
                      'Yes, both strategy and financial planning'
                    ]
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_3_VALUE,
                  fieldLabel:
                    'Primary reason for not having a climate transition plan that aligns with a 1.5°C world',
                  options:
                    PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_4_VALUE,
                  fieldLabel:
                    'Explain why environmental risks and/or opportunities have not affected your strategy and/or financial planning',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No',
                      'We have not evaluated whether environmental risks and opportunities have affected our strategy and financial planning, but plan to do so within the next two years'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'No',
                      'We have not evaluated whether environmental risks and opportunities have affected our strategy and financial planning, but plan to do so within the next two years'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.3.1 Describe where and how environmental risks and opportunities have affected your strategy. ',
            tooltip:
              'Through this question, data users seek to understand where the identified environmental risks and opportunities have affected your organization’s strategy. Your response to this question may be used to inform expectations about the future performance of your organization and how resilient your strategy is to environmental risks and opportunities. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_VALUE,
              showWhen: [
                'Yes, strategy only',
                'Yes, both strategy and financial planning'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q6_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE,
            showWhen: [
              'Yes, strategy only',
              'Yes, both strategy and financial planning'
            ],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q6_1_VALUE,
                  fieldLabel: 'Business area',
                  options: [
                    {
                      value: 'Products and services',
                      label: 'Products and services'
                    },
                    {
                      value: 'Upstream/downstream value chain',
                      label: 'Upstream/downstream value chain'
                    },
                    {value: 'Investment in R&D', label: 'Investment in R&D'},
                    {value: 'Operations', label: 'Operations'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q6_2_VALUE,
                  fieldLabel: 'Effect type',
                  options: [
                    {value: 'Risks', label: 'Risks'},
                    {value: 'Opportunities', label: 'Opportunities'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q6_3_VALUE,
                  fieldLabel:
                    'Environmental issues relevant to the risks and/or opportunities that have affected your strategy in this area',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q6_4_VALUE,
                  fieldLabel:
                    'Describe how environmental risks and/or opportunities have affected your strategy in this area',
                  colSpan: true,
                  textLimit: 3000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.3.2 Describe where and how environmental risks and opportunities have affected your financial planning.',
            tooltip:
              'Environmental issues can affect aspects of an organization’s financial position and performance, both now and in the future. Through this question, data users seek to understand where the identified environmental risks and opportunities have affected your financial position, and how this has been incorporated and addressed in your financial planning process',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_VALUE,
              showWhen: [
                'Yes, financial planning only',
                'Yes, both strategy and financial planning'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q7_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_1_VALUE,
            showWhen: [
              'Yes, financial planning only',
              'Yes, both strategy and financial planning'
            ],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q5_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q7_1_VALUE,
                  fieldLabel:
                    'Financial planning elements that have been affected',
                  options: [
                    {value: 'Revenues', label: 'Revenues'},
                    {value: 'Direct costs', label: 'Direct costs'},
                    {value: 'Indirect costs', label: 'Indirect costs'},
                    {
                      value: 'Capital expenditures',
                      label: 'Capital expenditures'
                    },
                    {value: 'Capital allocation', label: 'Capital allocation'},
                    {
                      value: 'Acquisitions and divestments',
                      label: 'Acquisitions and divestments'
                    },
                    {value: 'Access to capital', label: 'Access to capital'},
                    {value: 'Assets', label: 'Assets'},
                    {value: 'Liabilities', label: 'Liabilities'},
                    {
                      value: 'Provisions or general reserves [FS only]',
                      label: 'Provisions or general reserves [FS only]'
                    },
                    {
                      value: 'Claims reserves [FS only]',
                      label: 'Claims reserves [FS only]'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q7_2_VALUE,
                  fieldLabel: 'Effect type',
                  options: [
                    {value: 'Risks', label: 'Risks'},
                    {value: 'Opportunities', label: 'Opportunities'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q7_3_VALUE,
                  fieldLabel:
                    'Environmental issues relevant to the risks and/or opportunities have affected these financial planning elements',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q7_4_VALUE,
                  fieldLabel:
                    'Describe how environmental risks and/or opportunities have affected these financial planning elements',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.4 In your organization’s financial accounting, do you identify spending/revenue that is aligned with your organization’s climate transition?',
            tooltip:
              'Organizations need to be aware of whether their spending and revenue is supporting their climate transition. Basing such an assessment on activities, projects, or assets defined as sustainable by a sustainable finance taxonomy can inform progress being made on their commitment to mitigate and adapt to climate change and enhance its credibility. '
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_1_VALUE,
                  fieldLabel:
                    'Identification of spending/revenue that is aligned with your organization’s climate transition',
                  options: PROCESS_PLACE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_2_VALUE,
                  fieldLabel:
                    'Methodology or framework used to assess alignment with your organization’s climate transition',
                  options: [
                    {
                      value: 'A sustainable finance taxonomy',
                      label: 'A sustainable finance taxonomy'
                    },
                    {
                      value: 'Other methodology or framework',
                      label: 'Other methodology or framework'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_3_VALUE,
                  fieldLabel:
                    'Indicate the level at which you identify the alignment of your spending/revenue with a sustainable finance taxonomy',
                  options: [
                    {
                      value: 'At both the organization and activity level',
                      label: 'At both the organization and activity level'
                    },
                    {
                      value: 'At the organization level only',
                      label: 'At the organization level only'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_2_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['A sustainable finance taxonomy']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.4.1 Quantify the amount and percentage share of your spending/revenue that is aligned with your organization’s climate transition.',
            tooltip:
              'This question allows organizations to demonstrate the extent to which their spending and revenue is compatible with their climate transition, by assessing their alignment against a sustainable finance taxonomy and/or any other methodology. Such reporting is aimed at eliminating greenwashing in the organization’s financial planning in relation to its climate transition.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_1_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_1_VALUE,
                  fieldLabel:
                    'Methodology or framework used to assess alignment ',
                  options: [
                    {
                      value: 'A sustainable finance taxonomy',
                      label: 'A sustainable finance taxonomy'
                    },
                    {
                      value: 'Other please specify',
                      label: 'Other please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_2_VALUE,
                  fieldLabel:
                    'Taxonomy under which information is being reported',
                  options: [
                    {
                      value: 'EU Taxonomy for Sustainable Activities',
                      label: 'EU Taxonomy for Sustainable Activities'
                    },
                    {
                      value: 'Other please specify',
                      label: 'Other please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['A sustainable finance taxonomy']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_3_VALUE,
                  fieldLabel:
                    'Objective under which alignment is being reported',
                  options: [
                    {
                      value: 'Climate change mitigation',
                      label: 'Climate change mitigation'
                    },
                    {
                      value: 'Climate change adaptation',
                      label: 'Climate change adaptation'
                    },
                    {
                      value:
                        'Total across climate change mitigation and climate change adaption',
                      label:
                        'Total across climate change mitigation and climate change adaption'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['A sustainable finance taxonomy']
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_4_VALUE,
                  fieldLabel:
                    'Indicate whether you are reporting eligibility information for the selected objective',
                  options: ['Yes', 'No'],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['EU Taxonomy for Sustainable Activities']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_5_VALUE,
                  fieldLabel: 'Financial metric',
                  options: [
                    {value: 'Revenue/Turnover', label: 'Revenue/Turnover'},
                    {value: 'CAPEX', label: 'CAPEX'},
                    {value: 'OPEX', label: 'OPEX'},
                    {
                      value: 'Other please specify',
                      label: 'Other please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_6_VALUE,
                  fieldLabel:
                    'Amount of selected financial metric that is aligned in the reporting year (currency)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_7_VALUE,
                  fieldLabel:
                    'Percentage share of selected financial metric aligned in the reporting year (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_8_VALUE,
                  fieldLabel:
                    'Percentage share of selected financial metric planned to align in 2025 (%)',
                  colSpan: true,
                  roundTo: 6
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_9_VALUE,
                  fieldLabel:
                    'Percentage share of selected financial metric planned to align in 2030 (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_10_VALUE,
                  fieldLabel:
                    'Percentage share of financial metric that is taxonomy-eligible in the reporting year (%)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_11_VALUE,
                  fieldLabel:
                    'Percentage share of financial metric that is taxonomy non-eligible in the reporting year (%)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q9_12_VALUE,
                  fieldLabel:
                    'Details of the methodology or framework used to assess alignment with your organization’s climate transition',
                  colSpan: true,
                  textLimit: 4000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.4.2 Quantify the percentage share of your spending/revenue that was associated with eligible and aligned activities under the sustainable finance taxonomy in the reporting year.',
            tooltip:
              'This question allows organizations to provide evidence of the extent to which their spending and revenue is directed at/derived from activities defined as sustainable by a sustainable finance taxonomy. Such evidence is crucial to enhance transparency of the accounting practices used by organizations in their climate-related financial reporting.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_VALUE,
              showWhen: ['At both the organization and activity level'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_3_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_3_VALUE,
            showWhen: ['At both the organization and activity level'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_1_VALUE,
                  fieldLabel: 'Economic activity',
                  options: ECONOMIC_ACTIVITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_2_VALUE,
                  fieldLabel:
                    'Taxonomy under which information is being reported',
                  options: [
                    {
                      value: 'EU Taxonomy for Sustainable Activities',
                      label: 'EU Taxonomy for Sustainable Activities'
                    },
                    {
                      value: 'Other please specify',
                      label: 'Other please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                  fieldLabel: 'Taxonomy alignment',
                  options: [
                    {value: 'Taxonomy-aligned', label: 'Taxonomy-aligned'},
                    {
                      value: 'Taxonomy-eligible but not aligned',
                      label: 'Taxonomy-eligible but not aligned'
                    },
                    {value: 'Taxonomy-eligible', label: 'Taxonomy-eligible'},
                    {
                      value: 'alignment not assessed',
                      label: 'alignment not assessed'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_4_VALUE,
                  fieldLabel: 'Financial metrics',
                  options: [
                    {value: 'Turnover', label: 'Turnover'},
                    {value: 'CAPEX', label: 'CAPEX'},
                    {value: 'OPEX', label: 'OPEX'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_5_VALUE,
                  fieldLabel: 'Types of substantial contribution',
                  options: [
                    {value: 'Own performance', label: 'Own performance'},
                    {value: 'Adapted activity', label: 'Adapted activity'},
                    {
                      value: 'Transitional activity',
                      label: 'Transitional activity'
                    },
                    {
                      value: 'Activity enabling mitigation',
                      label: 'Activity enabling mitigation'
                    },
                    {
                      value: 'Activity enabling adaptation',
                      label: 'Activity enabling adaptation'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_6_VALUE,
                  fieldLabel:
                    'Taxonomy-aligned turnover from this activity in the reporting year (currency',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_7_VALUE,
                  fieldLabel:
                    'Taxonomy-aligned turnover from this activity as % of total turnover in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_4_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Turnover']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_8_VALUE,
                  fieldLabel:
                    'Taxonomy-aligned turnover from this activity that substantially contributed to climate change mitigation as a % of total turnover in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_9_VALUE,
                  fieldLabel:
                    'Taxonomyaligned turnover from this activity that substantially contributed to climate change adaptation as a % of total turnover in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_10_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible but not aligned turnover from this activity in the reporting year (currency)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_11_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible but not aligned turnover from this activity as % of total turnover in the reporting year ',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_12_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible, alignment not assessed turnover from this activity as % of total turnover in reporting year ',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_4_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Turnover']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_13_VALUE,
                  fieldLabel:
                    'Taxonomy-aligned CAPEX from this activity in the reporting year (currency)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_14_VALUE,
                  fieldLabel:
                    'Taxonomy -aligned CAPEX from this activity as % of total CAPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_4_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['CAPEX']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_15_VALUE,
                  fieldLabel:
                    'Taxonomyaligned CAPEX from this activity that substantially contributed to climate change mitigation as a % of total CAPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_16_VALUE,
                  fieldLabel:
                    'Taxonomyaligned CAPEX from this activity that substantially contributed to climate change adaptation as a % of total CAPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_17_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible but not aligned CAPEX associated with this activity in the reporting year (currency)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_18_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible but not aligned CAPEX associated with this activity as % of total CAPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_19_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible, alignment not assessed CAPEX associated with this activity as % of total CAPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_4_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['CAPEX']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_20_VALUE,
                  fieldLabel:
                    'Taxonomy-aligned OPEX from this activity in the reporting year (currency)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_21_VALUE,
                  fieldLabel:
                    'Taxonomyaligned OPEX from this activity as % of total OPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_4_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['OPEX']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_22_VALUE,
                  fieldLabel:
                    'Taxonomy-aligned OPEX from this activity that substantially contributed to climate change mitigation as a % of total OPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_23_VALUE,
                  fieldLabel:
                    'Taxonomy-aligned OPEX from this activity that substantially contributed to climate change adaptation as a % of total OPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Taxonomy-aligned']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_24_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible but not aligned OPEX associated with this activity in the reporting year (currency)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_25_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible but not aligned OPEX associated with this activity as % total OPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_26_VALUE,
                  fieldLabel:
                    'Taxonomy-eligible, alignment not assessed OPEX with this activity as % of total OPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_4_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['OPEX']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_27_VALUE,
                  fieldLabel:
                    'Calculation methodology and supporting information',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_28_VALUE,
                  fieldLabel: 'Substantial contribution criteria met',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_29_VALUE,
                  fieldLabel:
                    'Details of substantial contribution criteria analysis',
                  colSpan: true,
                  textLimit: 2500,
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_28_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_28_VALUE
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_30_VALUE,
                  fieldLabel: 'Do no significant harm requirements met',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_31_VALUE,
                  fieldLabel: 'Details of do no significant harm analysis',
                  colSpan: true,
                  textLimit: 2500,
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_30_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_30_VALUE
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_32_VALUE,
                  fieldLabel: 'Minimum safeguards compliance requirements met',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_33_VALUE,
                  fieldLabel: 'Attach any supporting evidence',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .businessStrategy
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.4.3 Provide any additional contextual and/or verification/assurance information relevant to your',
            tooltip:
              'This question helps data users interpret the information organizations provide on the alignment of their spending/revenue with a sustainable finance taxonomy. Assurance and verification provides confidence in the accuracy of data reported. Ambition Organizations are transparent about their approach to assessing alignment with sustainable finance taxonomies and the alignment is verified/assured by a third party.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_VALUE,
              showWhen: ['A sustainable finance taxonomy'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q11_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_2_VALUE,
            showWhen: ['A sustainable finance taxonomy'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q8_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q11_1_VALUE,
                  fieldLabel: 'Details of minimum safeguards analysis',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_32_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_32_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q10_32_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q11_2_VALUE,
                  fieldLabel:
                    'Additional contextual information relevant to your taxonomy alignment',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q11_3_VALUE,
                  fieldLabel:
                    'Indicate whether you will be providing verification/assurance information relevant to your taxonomy alignment in question 13.1',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q11_4_VALUE,
                  fieldLabel:
                    'Please explain why you will not be providing verification/assurance information relevant to your taxonomy alignment in question 13.1',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q11_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5 Does your organization invest in research and development (R&D) of low-carbon products or services',
            tooltip:
              'Investment in R&D of new low-carbon technologies is needed to mitigate transition risk.According to the TCFD recommendations, the level of investment provides an indication of how exposed future earning capacity is to climate risks'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_1_VALUE,
                  fieldLabel: 'Investment in low-carbon R&D',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.1 Provide details of your organization’s investments in low-carbon R&D for cement production activities',
            tooltip: ''
          },
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q13_VALUE,
            options: Q5_5_1_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.2 Provide details of your organization’s investments in low-carbon R&D for capital goods products and',
            tooltip: ''
          },
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q14_VALUE,
            options: Q5_5_2_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.3 Provide details of your organization’s investments in low-carbon R&D for chemical production',
            tooltip: ''
          },
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q15_VALUE,
            options: Q5_5_3_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.4 Provide details of your organization’s investments in low-carbon R&D for metals and mining',
            tooltip: ''
          },
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q16_VALUE,
            options: Q5_5_4_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.5 Provide details of your organization’s investments in low-carbon R&D for steel production activities',
            tooltip: ''
          },
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q17_VALUE,
            options: Q5_5_5_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.6 Provide details of your organization’s investments in low-carbon R&D for real estate and construction',
            tooltip: ''
          },
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q18_VALUE,
            options: Q5_5_6_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.7 Provide details of your organizations investments in low-carbon R&D for your sector activities over',
            tooltip:
              'Actions being taken by high intensity sectors are key in the transition to a low-carbon economy. Specifically, the level of investments in low-carbon R&D provides an indication of the level to which future earning capacity of core business might be affected, and the extent to which future resilience to climate-related issues can be incorporated in businesses. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_1_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_1_VALUE,
                  fieldLabel: 'Technology area',
                  options: TECHNOLOGY_AREA_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_2_VALUE,
                  fieldLabel: 'Stage of development in the reporting year',
                  options: [
                    {
                      value: 'Basic academic/theoretical research',
                      label: 'Basic academic/theoretical research'
                    },
                    {
                      value: 'Applied research and development',
                      label: 'Applied research and development'
                    },
                    {
                      value: 'Pilot demonstration',
                      label: 'Pilot demonstration'
                    },
                    {
                      value: 'Full/commercial scale demonstration',
                      label: 'Full/commercial scale demonstration'
                    },
                    {
                      value: 'Small scale commercial deployment',
                      label: 'Small scale commercial deployment'
                    },
                    {
                      value: 'Large scale commercial deployment',
                      label: 'Large scale commercial deployment'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Unable to disaggregate by technology area']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_3_VALUE,
                  fieldLabel:
                    'Average % of total R&D investment over the last 3 years',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_4_VALUE,
                  fieldLabel: 'R&D investment figure in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_5_VALUE,
                  fieldLabel:
                    'Average % of total R&D investment planned over the next 5 years',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q19_6_VALUE,
                  fieldLabel:
                    'Explain how your R&D investment in this technology area is aligned with your climate commitments and/or climate transition plan',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.5.8 Provide details of your organization’s investments in low-carbon R&D for transport-related activities',
            tooltip:
              'Actions being taken by high intensity sectors are key in the transition to a low-carbon economy. Specifically, the level of investments in low-carbon R&D provides an indication of the level to which future earning capacity of core business might be affected, and the extent to which future resilience to climate-related issues can be incorporated in businesses. Ambition Companies invest in R&D for clean technologies that are important for net-zero emissions.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_1_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q12_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_1_VALUE,
                  fieldLabel: 'Activity',
                  options: [
                    {
                      value: 'Light Duty Vehicles (LDV)',
                      label: 'Light Duty Vehicles (LDV)'
                    },
                    {
                      value: 'Heavy Duty Vehicles (HDV)',
                      label: 'Heavy Duty Vehicles (HDV)'
                    },
                    {value: 'Rail', label: 'Rail'},
                    {value: 'Marine', label: 'Marine'},
                    {value: 'Aviation', label: 'Aviation'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_2_VALUE,
                  fieldLabel: 'Technology area',
                  options: TECHNOLOGY_AREAS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_3_VALUE,
                  fieldLabel: 'Stage of development in the reporting year',
                  options: [
                    {
                      value: 'Basic academic/theoretical research',
                      label: 'Basic academic/theoretical research'
                    },
                    {
                      value: 'Applied research and development',
                      label: 'Applied research and development'
                    },
                    {
                      value: 'Pilot demonstration',
                      label: 'Pilot demonstration'
                    },
                    {
                      value: 'Full/commercial scale demonstration',
                      label: 'Full/commercial scale demonstration'
                    },
                    {
                      value: 'Small scale commercial deployment',
                      label: 'Small scale commercial deployment'
                    },
                    {
                      value: 'Large scale commercial deployment',
                      label: 'Large scale commercial deployment'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_4_VALUE,
                  fieldLabel:
                    'Average % of total R&D investment over the last 3 years',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_5_VALUE,
                  fieldLabel: 'R&D investment figure in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_6_VALUE,
                  fieldLabel:
                    'Average % of total R&D investment planned over the next 5 years',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q20_7_VALUE,
                  fieldLabel:
                    'Explain how your R&D investment in this technology area is aligned with your climate commitments and/or climate transition plan',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.6 Break down, by fossil fuel expansion activity, your organization’s CAPEX in the reporting year and CAPEX planned over the next 5 years.',
            tooltip:
              'This question captures data on current and future CAPEX on exploration or new development activities for these fossil fuels. Data users wish to understand whether organizations are investing in the exploration/expansion of new fossil fuel resources. Under the IEA NZE scenario, the key policy assumptions state that no new oil and gas field exploration should occur after 2021 and no new coal mines or coal mine extensions should be approved for development after 2021. Ambition There is no exploration of new oil & gas fields and no new coal mines/extensions from 2021 onwards.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q21_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q21_1_VALUE,
                  fieldLabel: 'Expansion activity',
                  options: [
                    {
                      value: 'Exploration of new oil fields [OG only]',
                      label: 'Exploration of new oil fields [OG only]'
                    },
                    {
                      value: 'Exploration of new natural gas fields [OG only]',
                      label: 'Exploration of new natural gas fields [OG only]'
                    },
                    {
                      value: 'Expansion of existing oil fields [OG only]',
                      label: 'Expansion of existing oil fields [OG only]'
                    },
                    {
                      value:
                        'Expansion of existing natural gas fields [OG only]',
                      label:
                        'Expansion of existing natural gas fields [OG only]'
                    },
                    {
                      value: 'Development of new coal mines [CO only]',
                      label: 'Development of new coal mines [CO only]'
                    },
                    {
                      value: 'Expansion of existing coal mines [CO only]',
                      label: 'Expansion of existing coal mines [CO only]'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q21_2_VALUE,
                  fieldLabel:
                    'CAPEX in the reporting year for this expansion activity (unit currency as selected in 1.2)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q21_3_VALUE,
                  fieldLabel:
                    'CAPEX in the reporting year for this expansion activity as % of total CAPEX in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q21_4_VALUE,
                  fieldLabel:
                    'CAPEX planned over the next 5 years for this expansion activity as % of total CAPEX planned over the next 5 years',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q21_5_VALUE,
                  fieldLabel:
                    'Explain your CAPEX calculations, including any assumptions',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.7 Break down, by source, your organization’s CAPEX in the reporting year and CAPEX planned over the next 5 years. ',
            tooltip:
              'Understanding an electric utility’s planned CAPEX for power generation in the reporting year and over the next 5 years informs the vulnerability of the organization to emerging climaterelated risks and opportunities and the flexibility to continue the current technology portfolio at lower financial returns in a transition period to low-carbon technologies. Ambition There are no new unabated coal plants approved for development from 2021 onwards.',
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_1_VALUE,
                  fieldLabel: 'Primary power generation source',
                  options: [
                    {value: 'Coal – hard', label: 'Coal – hard'},
                    {value: 'Lignite', label: 'Lignite'},
                    {value: 'Oil', label: 'Oil'},
                    {value: 'Gas', label: 'Gas'},
                    {
                      value: 'Sustainable biomass',
                      label: 'Sustainable biomass'
                    },
                    {value: 'Other biomass', label: 'Other biomass'},
                    {
                      value: 'Waste (non-biomass)',
                      label: 'Waste (non-biomass)'
                    },
                    {value: 'Nuclear', label: 'Nuclear'},
                    {value: 'Geothermal', label: 'Geothermal'},
                    {value: 'Hydropower', label: 'Hydropower'},
                    {value: 'Wind', label: 'Wind'},
                    {value: 'Solar', label: 'Solar'},
                    {value: 'Marine', label: 'Marine'},
                    {
                      value: 'Fossil-fuel plants fitted with CCS',
                      label: 'Fossil-fuel plants fitted with CCS'
                    },
                    {
                      value: 'Other renewable (e.g. renewable hydrogen)',
                      label: 'Other renewable (e.g. renewable hydrogen)'
                    },
                    {
                      value:
                        'Other non-renewable (e.g. non-renewable hydrogen)',
                      label: 'Other non-renewable (e.g. non-renewable hydrogen)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_2_VALUE,
                  fieldLabel:
                    'CAPEX in the reporting year for power generation from this source (unit currency as selected in 1.2)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_3_VALUE,
                  fieldLabel:
                    'CAPEX in the reporting year for power generation from this source as % of total CAPEX for power generation in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_4_VALUE,
                  fieldLabel:
                    'CAPEX planned over the next 5 years for power generation from this source as % of total CAPEX planned for power generation over the next 5 years',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_5_VALUE,
                  fieldLabel:
                    'Most recent year in which a new power plant using this source was approved for development',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q22_6_VALUE,
                  fieldLabel:
                    'Explain your CAPEX calculations, including any assumptions',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.7.1 Break down your total planned CAPEX in your current CAPEX plan for products and services (e.g. smart grids, digitalization, etc.).',
            tooltip:
              'The advancement of decentralized power production and new technologies underpins the potential of the electric utilities sector to undergo a transition to low-carbon energy sources. The level of investment in emerging products and services provides an indication of the level to which future earning capacity of core business might be impacted.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q23_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q23_1_VALUE,
                  fieldLabel: 'Products and services',
                  options: [
                    {
                      value: 'Distributed generation',
                      label: 'Distributed generation'
                    },
                    {
                      value: 'Home storage systems',
                      label: 'Home storage systems'
                    },
                    {value: 'Smart appliances', label: 'Smart appliances'},
                    {value: 'Home systems', label: 'Home systems'},
                    {value: 'Prosumer services', label: 'Prosumer services'},
                    {
                      value: 'Information campaigns',
                      label: 'Information campaigns'
                    },
                    {value: 'Audits', label: 'Audits'},
                    {value: 'Tariff measures', label: 'Tariff measures'},
                    {value: 'Energy audits', label: 'Energy audits'},
                    {
                      value: 'Energy management services',
                      label: 'Energy management services'
                    },
                    {value: 'Electric vehicles', label: 'Electric vehicles'},
                    {value: 'Charging networks', label: 'Charging networks'},
                    {value: 'Heating systems', label: 'Heating systems'},
                    {value: 'HVAC', label: 'HVAC'},
                    {value: 'CHP', label: 'CHP'},
                    {value: 'Lighting', label: 'Lighting'},
                    {value: 'Smart grid', label: 'Smart grid'},
                    {value: 'Micro-grid', label: 'Micro-grid'},
                    {
                      value: 'Large-scale storage',
                      label: 'Large-scale storage'
                    },
                    {
                      value: 'Other please specify',
                      label: 'Other please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q23_2_VALUE,
                  fieldLabel: 'Description of product/service',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q23_3_VALUE,
                  fieldLabel: 'CAPEX planned for product/service ',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q23_4_VALUE,
                  fieldLabel:
                    'Percentage of total CAPEX planned for products and services ',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q23_5_VALUE,
                  fieldLabel: 'End year of CAPEX plan',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.9 What is the trend in your organization’s water-related capital expenditure (CAPEX) and operating expenditure (OPEX) for the reporting year, and the anticipated trend for the next reporting year?',
            tooltip:
              'Within a company, this information raises the strategic understanding of the value of water for the business (beyond the price paid for it). Signalling the direction of travel of capital expenditure and operating expenditure to CDP data users helps them understand their potential exposure. The question asks for a reporting of trends and not absolute values. It identifies changes in water-related investment and operational costs. The information provided here should align with the information provided on risk response strategies and business opportunities (reported in 3.1 and 3.6). '
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q24_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q24_1_VALUE,
                  fieldLabel: 'Water-related CAPEX (+/- % change)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q24_2_VALUE,
                  fieldLabel:
                    'Anticipated forward trend for CAPEX (+/- % change)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q24_3_VALUE,
                  fieldLabel: 'Water-related OPEX (+/- % change)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q24_4_VALUE,
                  fieldLabel:
                    'Anticipated forward trend for OPEX (+/- % change)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q24_5_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 1000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.10 Does your organization use an internal price on environmental externalities?',
            tooltip:
              'Internal pricing of environmental externalities (i.e., a carbon price or water price) has emerged as a multifaceted tool that supports organizations in assessing environmental risks and opportunities. Data users are keen to understand how organizations attribute a monetary value to these risks and translate them into a uniform metric. Applying an internal price to these externalities can help an organization to understand opportunities for efficiencies and prepare for potential future price changes.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_1_VALUE,
                  fieldLabel:
                    'Use of internal pricing of environmental externalities',
                  options: PROCESS_PLACE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_2_VALUE,
                  fieldLabel: 'Environmental externality priced',
                  options: [
                    {value: 'Carbon', label: 'Carbon'},
                    {value: 'Water', label: 'Water'},
                    {value: 'Other', label: 'Other'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_3_VALUE,
                  fieldLabel:
                    'Primary reason for not pricing environmental externalities',
                  options:
                    PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_4_VALUE,
                  fieldLabel:
                    'Explain why your organization does not price environmental externalities',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_5_VALUE,
                  fieldLabel: 'Other environmental externalities priced ',
                  options: [
                    {value: 'Forests', label: 'Forests'},
                    {value: 'Plastics', label: 'Plastics'},
                    {value: 'Biodiversity', label: 'Biodiversity'},
                    {value: 'Water', label: 'Water'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_6_VALUE,
                  fieldLabel:
                    'Further details of other environmental externalities priced',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.10.1 Provide details of your organization’s internal price on carbon.',
            tooltip:
              'An internal price on an environmental externality (e.g., a carbon price) can be used as a tool to manage environmental risks and opportunities within an organization’s operations, value chain, and investments. As part of their assessment of an organization’s resilience, it is useful for data users to know how organizations are using an internal price on carbon. This information allows data users to assess how effectively an organization implements its internal carbon price to achieve its environmental objectives.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_VALUE,
              showWhen: ['Carbon'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_2_VALUE,
            showWhen: ['Carbon'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_1_VALUE,
                  fieldLabel: 'Type of pricing scheme',
                  options: TYPE_OF_PRICING_SCHEME_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_2_VALUE,
                  fieldLabel: 'Objectives for implementing internal price',
                  options: OBJECTIVES_FOR_IMPLEMENTING_INTERNAL_PRICE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_3_VALUE,
                  fieldLabel: 'Factors considered when determining the price',
                  options:
                    FACTORS_CONSIDERED_WHEN_DETERMINING_THE_PRICE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_4_VALUE,
                  fieldLabel:
                    'Calculation methodology and assumptions made in determining the price',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_5_VALUE,
                  fieldLabel: 'Scopes covered',
                  options: SCOPES_COVERED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_6_VALUE,
                  fieldLabel: 'Pricing approach used – spatial variance',
                  options: [
                    {value: 'Differentiated', label: 'Differentiated'},
                    {value: 'Uniform', label: 'Uniform'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_7_VALUE,
                  fieldLabel:
                    'Indicate how and why the price is differentiated',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_6_VALUE,
                    condition: conditionType.NOT,
                    values: ['Differentiated']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_8_VALUE,
                  fieldLabel: 'Pricing approach used – temporal variance',
                  options: [
                    {value: 'Evolutionary', label: 'Evolutionary'},
                    {value: 'Static', label: 'Static'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_9_VALUE,
                  fieldLabel:
                    'Indicate how you expect the price to change over time',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_8_VALUE,
                    condition: conditionType.NOT,
                    values: ['Evolutionary']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_10_VALUE,
                  fieldLabel:
                    'Minimum actual price used (currency per metric ton CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_11_VALUE,
                  fieldLabel:
                    'Maximum actual price used (currency per metric ton CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_12_VALUE,
                  fieldLabel:
                    'Business decisionmaking processes the internal price is applied to',
                  options:
                    BUSINESS_DECISIONMAKING_PROCESSES_THE_INTERNAL_PRICE_IS_APPLIED_TO_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_13_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, for some decision-making processes, please specify'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_13_VALUE,
                  fieldLabel:
                    'Internal price is mandatory within business decision-making processes',
                  options: [
                    {
                      value: 'Yes, for all decision-making processes',
                      label: 'Yes, for all decision-making processes'
                    },
                    {
                      value:
                        'Yes, for some decision-making processes, please specify',
                      label:
                        'Yes, for some decision-making processes, please specify'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_14_VALUE,
                  fieldLabel:
                    '% total emissions in the reporting year in selected scopes this internal price covers',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_15_VALUE,
                  fieldLabel:
                    'Pricing approach is monitored and evaluated to achieve objectives',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q26_16_VALUE,
                  fieldLabel:
                    'Details of how the pricing approach is monitored and evaluated to achieve your objectives',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.10.2 Provide details of your organization’s internal price on water.',
            tooltip:
              'The true value of water is not accounted for in today’s markets in many parts of the world, while the costs of treatment and delivery, as well as opportunity costs and environmental and social costs, are not well captured. As water becomes increasingly scarce and contested, businesses could see prices increase. Applying an internal price on water that more accurately reflects the costs of the organization’s water provision can help it understand opportunities for efficiencies and prepare for potential future price changes. As part of their assessment of an organization’s resilience, it is useful for data users to know if organizations are using an internal price on water. This information allows data users to assess how effectively an organization implements its internal water price to achieve its environmental objectives.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_VALUE,
              showWhen: ['Water'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_2_VALUE,
            showWhen: ['Water'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q25_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_1_VALUE,
                  fieldLabel: 'Type of pricing scheme',
                  options: TYPE_OF_PRICING_SCHEME_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_2_VALUE,
                  fieldLabel: 'Objectives for implementing internal price',
                  options: OBJECTIVES_FOR_IMPLEMENTING_INTERNAL_PRICE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                  fieldLabel:
                    'Factors beyond current market price are considered in the price',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_4_VALUE,
                  fieldLabel: 'Factors considered when determining the price',
                  options:
                    FACTORS_CONSIDERED_WHEN_DETERMINING_THE_PRICE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_5_VALUE,
                  fieldLabel:
                    'Calculation methodology and assumptions made in determining the price',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_6_VALUE,
                  fieldLabel: 'Stages of the value chain covered .',
                  options: [
                    {value: 'Direct operations', label: 'Direct operations'},
                    {
                      value: 'Upstream value chain',
                      label: 'Upstream value chain'
                    },
                    {
                      value: 'Downstream value chain',
                      label: 'Downstream value chain'
                    },
                    {value: 'Portfolio', label: 'Portfolio'},
                    {
                      value: 'Project/site specific coverage',
                      label: 'Project/site specific coverage'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_7_VALUE,
                  fieldLabel: 'Pricing approach used – spatial variance',
                  options: [
                    {value: 'Differentiated', label: 'Differentiated'},
                    {value: 'Uniform', label: 'Uniform'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_8_VALUE,
                  fieldLabel:
                    'Indicate how and why the price is differentiated',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_7_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Differentiated'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_7_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_9_VALUE,
                  fieldLabel: 'Pricing approach used – temporal variance',
                  options: [
                    {value: 'Evolutionary', label: 'Evolutionary'},
                    {value: 'Static', label: 'Static'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_10_VALUE,
                  fieldLabel:
                    'Indicate how you expect the price to change over time',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_9_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Evolutionary'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_9_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_11_VALUE,
                  fieldLabel: 'Minimum actual price used (currency per metric)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_12_VALUE,
                  fieldLabel: 'Maximum actual price used (currency per metric)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_13_VALUE,
                  fieldLabel:
                    'Business decision making processes the internal price is applied to',
                  options:
                    BUSINESS_DECISIONMAKING_PROCESSES_THE_INTERNAL_PRICE_IS_APPLIED_TO_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_14_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_14_VALUE,
                  fieldLabel:
                    'Internal price is mandatory within business decision-making processes',
                  options: [
                    {
                      value: 'Yes, for all decision-making processes',
                      label: 'Yes, for all decision-making processes'
                    },
                    {
                      value:
                        'Yes, for some decision-making processes, please specify',
                      label:
                        'Yes, for some decision-making processes, please specify'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_15_VALUE,
                  fieldLabel:
                    'Pricing approach is monitored and evaluated to achieve objectives',
                  options: ['Yes', 'No'],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_16_VALUE,
                  fieldLabel:
                    'Details of how the pricing approach is monitored and evaluated to achieve your objectives',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11 Do you engage with your value chain on environmental issues?',
            tooltip:
              'Engaging with value chain stakeholders is essential for organizations to drive progress on environmental issues associated with their operations. There are multiple drivers, benefits, and ranges of engagement relating to each environmental issue, from environmental requirements for suppliers to innovative partnerships for environmental stewardship with product users. If you are not engaging with your value chain on environmental issues, data users wish to know why you are not engaging in any way and what your plans are to do so in the future. '
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_1_VALUE,
                  fieldLabel: 'Value chain stakeholder',
                  options: [
                    {value: 'Clients', label: 'Clients'},
                    {
                      value: 'Investees',
                      label: 'Investees'
                    },
                    {value: 'Suppliers', label: 'Suppliers'},
                    {
                      value: 'Smallholders',
                      label: 'Smallholders'
                    },
                    {
                      value: 'Customers',
                      label: 'Customers'
                    },
                    {
                      value: 'Investors and shareholders',
                      label: 'Investors and shareholders'
                    },
                    {
                      value: 'Other value chain stakeholders',
                      label: 'Other value chain stakeholders'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
                  fieldLabel:
                    'Engaging with this stakeholder on environmental issues ',
                  options: PROCESS_PLACE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_3_VALUE,
                  fieldLabel: 'Environmental issue Covered ',
                  options: [
                    {value: 'Climate change', label: 'Climate change'},
                    {value: 'Forests', label: 'Forests'},
                    {value: 'Water', label: 'Water'},
                    {value: 'Plastics', label: 'Plastics'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_4_VALUE,
                  fieldLabel:
                    'Primary reason for not engaging with this stakeholder on environmental issues ',
                  options: [
                    {
                      value:
                        'We are producers, and do not have any commodity suppliers [Suppliers row only]',
                      label:
                        'We are producers, and do not have any commodity suppliers [Suppliers row only]'
                    },
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {
                      value: 'Judged to be unimportant or not relevant',
                      label: 'Judged to be unimportant or not relevant'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, but we plan to within the next two years',
                      'No, and we do not plan to within the next two years'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_5_VALUE,
                  fieldLabel:
                    'Explain why you do not engage with this stakeholder on environmental issues',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, but we plan to within the next two years',
                      'No, and we do not plan to within the next two years'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.1 Does your organization assess and classify suppliers according to their dependencies and/or impacts on the environment?',
            tooltip:
              'The assessment of an organization’s supplier dependencies and impacts on the environment allows for action to be informed and targeted to where the effect of environmental dependencies and impacts is greatest. This question allows data users to understand whether an organization is aware of where environmental dependencies and/or impacts exist in its upstream value chain. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_1_VALUE,
                  fieldLabel: 'Environmental issue covered',
                  options: [
                    {value: 'Climate change', label: 'Climate change'},
                    {value: 'Forests', label: 'Forests'},
                    {value: 'Water', label: 'Water'},
                    {value: 'Plastics', label: 'Plastics'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_2_VALUE,
                  fieldLabel:
                    'Assessment of supplier dependencies and/or impacts on the environment',
                  options: [
                    {
                      value:
                        'Yes, we assess the dependencies and/or impacts of our suppliers',
                      label:
                        'Yes, we assess the dependencies and/or impacts of our suppliers'
                    },
                    {
                      value:
                        'No, we do not currently assess the dependencies and/or impacts of our suppliers, but we plan to do so within the next two years',
                      label:
                        'No, we do not currently assess the dependencies and/or impacts of our suppliers, but we plan to do so within the next two years'
                    },
                    {
                      value:
                        'No, we do not assess the dependencies and/or impacts of our suppliers, and have no plans to do so within two years',
                      label:
                        'No, we do not assess the dependencies and/or impacts of our suppliers, and have no plans to do so within two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_3_VALUE,
                  fieldLabel:
                    'Criteria for assessing supplier dependencies and/or impacts on the environment .',
                  options:
                    ASSESSMENT_OF_SUPPLIER_DEPENDENCIES_AND_OR_IMPACTS_ON_THE_ENVIRONMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_4_VALUE,
                  fieldLabel: '% Tier 1 suppliers assessed',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_5_VALUE,
                  fieldLabel:
                    'Define a threshold for classifying suppliers as having substantive dependencies and/or impacts on the environment',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_6_VALUE,
                  fieldLabel:
                    '% Tier 1 suppliers meeting the threshold for substantive dependencies and/or impacts on the environment',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q29_7_VALUE,
                  fieldLabel:
                    'Number of Tier 1 suppliers meeting the thresholds for substantive dependencies and/or impacts on the environment',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },

      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.2 Does your organization prioritize which suppliers to engage with on environmental issues?',
            tooltip:
              'No change Ambition The organization prioritizes engagement with specific suppliers on environmental issues, guided by their dependencies and/or impact on the environment. Please complete the following table: This question allows data users to understand whether an organization prioritizes specific suppliers for engagement on environmental issues and, if so, the criteria employed in this prioritization to ensure that engagement achieves the greatest benefits.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_1_VALUE,
                  fieldLabel: 'Environmental issue covered',
                  options: [
                    {value: 'Climate change', label: 'Climate change'},
                    {value: 'Forests', label: 'Forests'},
                    {value: 'Water', label: 'Water'},
                    {value: 'Plastics', label: 'Plastics'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_2_VALUE,
                  fieldLabel:
                    'Supplier engagement prioritization on this environmental issue',
                  options: [
                    {
                      value:
                        'Yes, we prioritize which suppliers to engage with on this environmental issue',
                      label:
                        'Yes, we prioritize which suppliers to engage with on this environmental issue'
                    },
                    {
                      value:
                        'No, we do not prioritize which suppliers to engage with on this environmental issue',
                      label:
                        'No, we do not prioritize which suppliers to engage with on this environmental issue'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_3_VALUE,
                  fieldLabel:
                    'Criteria informing which suppliers are prioritized for engagement on this environmental issue',
                  options:
                    CRITERIA_INFORMING_WHICH_SUPPLIERS_ARE_PRIORITIZED_FOR_ENGAGEMENT_ON_THIS_ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_4_VALUE,
                  fieldLabel:
                    'Primary reason for no supplier prioritization on this environmental issue',
                  options: [
                    {
                      value: 'We engage with all suppliers',
                      label: 'We engage with all suppliers'
                    },
                    {
                      value:
                        'Lack of internal resources, capabilities or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {
                      value: 'Judged to be unimportant or not relevant',
                      label: 'Judged to be unimportant or not relevant'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_5_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_2_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, we prioritize which suppliers to engage with on this environmental issue',
                      'No, we do not prioritize which suppliers to engage with on this environmental issue'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q30_2_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.3 Provide details of your environmental engagement strategy with your clients.',
            tooltip:
              'This question provides data users with more transparency regarding an organization’s client engagement processes. Data users are interested in understanding how financial services companies are working with their clients to drive environmental action, such as whether organizations encourage their corporate clients to set science-based targets. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_1_VALUE,
                  fieldLabel: 'Type of clients',
                  options: [
                    {value: 'Clients of Banks', label: 'Clients of Banks'},
                    {
                      value: 'Clients of Asset Managers',
                      label: 'Clients of Asset Managers'
                    },
                    {value: 'Clients of Insurers', label: 'Clients of Insurers'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_2_VALUE,
                  fieldLabel:
                    'Environmental issues covered by the engagement strategy',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_3_VALUE,
                  fieldLabel: 'Type and details of engagement ',
                  options: TYPE_AND_DETAILS_OF_ENGAGEMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_4_VALUE,
                  fieldLabel:
                    '% of client-associated scope 3 emissions as reported in question 12.1.1',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Climate change']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_5_VALUE,
                  fieldLabel:
                    '% of portfolio covered in relation to total portfolio value',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_6_VALUE,
                  fieldLabel:
                    'Explain the rationale for the coverage of your engagement',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_7_VALUE,
                  fieldLabel:
                    'Describe how you communicate your engagement strategy to your clients and/or to the public',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_8_VALUE,
                  fieldLabel: 'Attach your engagement strategy',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .businessStrategy
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_9_VALUE,
                  fieldLabel:
                    'Staff in your organization carrying out the engagement .',
                  options:
                    STAFF_IN_YOUR_ORGANIZATION_CARRYING_OUT_THE_ENGAGEMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_10_VALUE,
                  fieldLabel:
                    'Roles of individuals at the portfolio organizations you seek to engage with .',
                  options:
                    ROLES_OF_INDIVIDUALS_AT_THE_PORTFOLIO_ORGANIZATIONS_YOU_SEEK_TO_ENGAGE_WITH_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_11_VALUE,
                  fieldLabel:
                    'Effect of engagement, including measures of success',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_12_VALUE,
                  fieldLabel:
                    'Escalation process for engagement when dialogue is failing',
                  options: [
                    {
                      value: 'Yes, we have an escalation process',
                      label: 'Yes, we have an escalation process'
                    },
                    {
                      value: 'No, we don’t have an escalation process',
                      label: 'No, we don’t have an escalation process'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_13_VALUE,
                  fieldLabel: 'Describe your escalation process',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_12_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes, we have an escalation process']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_12_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes, we have an escalation process'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q31_12_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.4 Provide details of your environmental engagement strategy with your investees.',
            tooltip:
              'This question appears if select “Yes” in response to column 1 “Engaging with this stakeholder on environmental issues” for the row “Investees” of 5.11. Modified guidance This question provides data users with more transparency regarding investee engagement processes. Data users are interested in understanding how financial services companies are working with their investees to drive environmental action, such as whether organizations encourage their investees to set science-based targets. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_1_VALUE,
                  fieldLabel:
                    'Environmental issues covered by the engagement strategy .',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_2_VALUE,
                  fieldLabel: 'Type and details of engagement ',
                  options: TYPE_AND_DETAILS_OF_ENGAGEMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_3_VALUE,
                  fieldLabel:
                    '% of scope 3 investees associated emissions as reported in 12.1.1/12.1.3',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_1_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Climate change']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_4_VALUE,
                  fieldLabel:
                    '% of investing (Asset managers) portfolio covered in relation to total portfolio value',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_5_VALUE,
                  fieldLabel:
                    '% of investing (Asset owners) portfolio covered in relation to total portfolio value',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_6_VALUE,
                  fieldLabel:
                    'Explain the rationale for the coverage of your engagement',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_7_VALUE,
                  fieldLabel:
                    'Describe how you communicate your engagement strategy to your clients and/or to the public',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_8_VALUE,
                  fieldLabel: 'Attach your engagement strategy',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .businessStrategy
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_9_VALUE,
                  fieldLabel:
                    'Staff in your organization carrying out the engagement .',
                  options:
                    STAFF_IN_YOUR_ORGANIZATION_CARRYING_OUT_THE_ENGAGEMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_10_VALUE,
                  fieldLabel:
                    'Roles of individuals at the portfolio organizations you seek to engage with .',
                  options:
                    ROLES_OF_INDIVIDUALS_AT_THE_PORTFOLIO_ORGANIZATIONS_YOU_SEEK_TO_ENGAGE_WITH_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_11_VALUE,
                  fieldLabel:
                    'Effect of engagement, including measures of success',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_12_VALUE,
                  fieldLabel:
                    'Escalation process for engagement when dialogue is failing',
                  options: [
                    {
                      value: 'Yes, we have an escalation process',
                      label: 'Yes, we have an escalation process'
                    },
                    {
                      value: 'No, we don’t have an escalation process',
                      label: 'No, we don’t have an escalation process'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_13_VALUE,
                  fieldLabel: 'Describe your escalation process',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_12_VALUE,
                    condition: conditionType.EMPTY,
                    values: ['Yes, we have an escalation process']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_12_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes, we have an escalation process'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q32_12_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.5 Do your suppliers have to meet environmental requirements as part of your organization’s purchasing process?',
            tooltip:
              'Setting environmental requirements for suppliers is a manifestation of strategic commitment to environmental action that not only enhances organizations’ awareness of environmental concerns but also serves as a powerful catalyst for driving transformative action throughout the upstream value chain. By setting stringent environmental requirements for suppliers, organizations assert their dedication to proactive change, fostering a culture of responsibility that resonates throughout value chains and industries, and paves the way for a more sustainable future. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_1_VALUE,
                  fieldLabel: 'Environmental issues covered',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_2_VALUE,
                  fieldLabel:
                    'Suppliers have to meet specific environmental requirements related to this environmental issue as part of the purchasing process',
                  options: [
                    {
                      value:
                        'Yes, environmental requirements related to this environmental issue are included in our supplier contracts',
                      label:
                        'Yes, environmental requirements related to this environmental issue are included in our supplier contracts'
                    },
                    {
                      value:
                        'Yes, suppliers have to meet environmental requirements related to this environmental issue, but they are not included in our supplier contracts',
                      label:
                        'Yes, suppliers have to meet environmental requirements related to this environmental issue, but they are not included in our supplier contracts'
                    },
                    {
                      value:
                        'No, but we plan to introduce environmental requirements related to this environmental issue within the next two years',
                      label:
                        'No, but we plan to introduce environmental requirements related to this environmental issue within the next two years'
                    },
                    {
                      value:
                        'No, and we do not plan to introduce environmental requirements related to this environmental issue within the next two years',
                      label:
                        'No, and we do not plan to introduce environmental requirements related to this environmental issue within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_3_VALUE,
                  fieldLabel:
                    'Policy in place for addressing supplier non-compliance',
                  options: [
                    {
                      value:
                        'Yes, we have a policy in place for addressing non-compliance',
                      label:
                        'Yes, we have a policy in place for addressing non-compliance'
                    },
                    {
                      value:
                        'No, we do not have a policy in place for addressing non-compliance',
                      label:
                        'No, we do not have a policy in place for addressing non-compliance'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, suppliers have to meet environmental requirements related to this environmental issue, but they are not included in our supplier contracts',
                      'Yes, environmental requirements related to this environmental issue are included in our supplier contracts'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 1500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.6 Provide details of the environmental requirements that suppliers have to meet as part of your organization’s purchasing process, and the compliance measures in place. ',
            tooltip:
              'Identifying key actions in the upstream value chain and fostering engagement through environmental requirements enables organizations to proactively mitigate risks. This question allows organizations to demonstrate the robustness of environmental requirements for their suppliers by highlighting the targeted environmental actions, the organizations’ engagement range, and non-compliance responses. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_VALUE,
              showWhen: [
                'Yes, environmental requirements related to this environmental issue are included in our supplier contracts',
                'Yes, suppliers have to meet environmental requirements related to this environmental issue, but they are not included in our supplier contracts'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_2_VALUE,
            showWhen: [
              'Yes, environmental requirements related to this environmental issue are included in our supplier contracts',
              'Yes, suppliers have to meet environmental requirements related to this environmental issue, but they are not included in our supplier contracts'
            ],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q33_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_1_VALUE,
                  fieldLabel: 'Environmental issues covered',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_2_VALUE,
                  fieldLabel: 'Environmental requirement',
                  options: ENVIRONMENTAL_REQUIREMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_3_VALUE,
                  fieldLabel:
                    'Mechanisms for monitoring compliance with this environmental requirement .',
                  options:
                    MECHANISMS_FOR_MONITORING_COMPLIANCE_WITH_THIS_ENVIRONMENTAL_REQUIREMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_4_VALUE,
                  fieldLabel:
                    '% tier 1 suppliers by procurement spend required to comply with this environmental requirement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_5_VALUE,
                  fieldLabel:
                    '% tier 1 suppliers by procurement spend in compliance with this environmental requirement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_6_VALUE,
                  fieldLabel:
                    '% tier 1 suppliers with substantive environmental dependencies and/or impacts related to this environmental issue required to comply with this environmental requirement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_7_VALUE,
                  fieldLabel:
                    '% tier 1 suppliers with substantive environmental dependencies and/or impacts related to this environmental issue that are in compliance with this environmental requirement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_8_VALUE,
                  fieldLabel:
                    '% tier 1 supplierrelated scope 3 emissions attributable to the  suppliers required to comply with this environmental requirement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Climate change']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_9_VALUE,
                  fieldLabel:
                    '% tier 1 supplierrelated scope 3 emissions attributable to the suppliers in compliance with this environmental requirement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Climate change']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_10_VALUE,
                  fieldLabel:
                    'Response to supplier noncompliance with this environmental requirement',
                  options: [
                    {value: 'Exclude', label: 'Exclude'},
                    {value: 'No response', label: 'No response'},
                    {value: 'Retain and engage', label: 'Retain and engage'},
                    {value: 'Suspend and engage', label: 'Suspend and engage'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_11_VALUE,
                  fieldLabel: 'Procedures to engage noncompliant suppliers .',
                  options: [
                    {
                      value:
                        'Assessing the efficacy and efforts of noncompliant supplier actions through consistent and quantified metrics',
                      label:
                        'Assessing the efficacy and efforts of noncompliant supplier actions through consistent and quantified metrics'
                    },
                    {
                      value:
                        'Developing quantifiable, time-bound targets and milestones to bring suppliers back into compliance',
                      label:
                        'Developing quantifiable, time-bound targets and milestones to bring suppliers back into compliance'
                    },
                    {
                      value:
                        'Providing information on appropriate actions that can be taken to address noncompliance',
                      label:
                        'Providing information on appropriate actions that can be taken to address noncompliance'
                    },
                    {
                      value:
                        'Reintegrating suppliers back into upstream value chain based on the successful and verifiable completion of activities',
                      label:
                        'Reintegrating suppliers back into upstream value chain based on the successful and verifiable completion of activities'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_12_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q34_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Compliance with an environmental certification, please specify'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.7 Provide further details of your organization’s supplier engagement on environmental issues.',
            tooltip:
              'Proactive supplier engagement on environmental initiatives showcases an organization’s commitment to driving environmental action. This question facilitates data users’ evaluation of an organization’s sustainability efforts in their value chain, by revealing how comprehensive their understanding is of environmental issues throughout their upstream value chain. This comprehensive awareness allows organizations to manage environmental issues holistically, benefiting from a more thorough understanding of dependencies, impacts, risks, and opportunities within their upstream value chain.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_1_VALUE,
                  fieldLabel: 'Environmental issue covered',
                  options: [
                    {value: 'Climate change', label: 'Climate change'},
                    {value: 'Forests', label: 'Forests'},
                    {value: 'Water', label: 'Water'},
                    {value: 'Plastics', label: 'Plastics'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_2_VALUE,
                  fieldLabel: 'Commodity',
                  options: [
                    {
                      value: 'Cattle products (e.g., beef, leather)',
                      label: 'Cattle products (e.g., beef, leather)'
                    },
                    {value: 'Palm oil', label: 'Palm oil'},
                    {value: 'Soy', label: 'Soy'},
                    {value: 'Timber products', label: 'Timber products'},
                    {value: 'Cocoa', label: 'Cocoa'},
                    {value: 'Coffee', label: 'Coffee'},
                    {value: 'Rubber', label: 'Rubber'},
                    {value: 'Not applicable', label: 'Not applicable'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_3_VALUE,
                  fieldLabel: 'Action driven by supplier engagement',
                  options: ACTION_DRIVEN_BY_SUPPLIER_ENGAGEMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_4_VALUE,
                  fieldLabel: 'Type and details of engagement',
                  options: TYPE_AND_DETAILS_OF_ENGAGEMENT_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No other supplier engagement']
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_5_VALUE,
                  fieldLabel: 'Upstream value chain coverage',
                  options: SUPPLIER_TIER_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_6_VALUE,
                  fieldLabel:
                    '% of tier 1 suppliers by procurement spend covered by engagement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_7_VALUE,
                  fieldLabel:
                    '% of tier 1 supplierrelated scope 3 emissions covered by engagement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Climate change']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_8_VALUE,
                  fieldLabel:
                    '% tier 1 suppliers with substantive impacts and/or dependencies related to this environmental issue covered by engagement',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Forests', 'Water']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_9_VALUE,
                  fieldLabel: 'Number of tier 2+ suppliers engaged',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_5_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Tier 2 suppliers']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_10_VALUE,
                  fieldLabel:
                    'Describe the engagement and explain the effect of your engagement on the selected environmental action',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['No other supplier engagement']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_11_VALUE,
                  fieldLabel:
                    'Engagement is helping your tier 1 suppliers meet an environmental requirement related to this environmental issue',
                  options: [
                    {
                      value:
                        'Yes, please specify the environmental requirement',
                      label: 'Yes, please specify the environmental requirement'
                    },
                    {
                      value:
                        'No, this engagement is unrelated to meeting an environmental requirement',
                      label:
                        'No, this engagement is unrelated to meeting an environmental requirement'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q35_12_VALUE,
                  fieldLabel:
                    'Engagement is helping your tier 1 suppliers engage with their own suppliers on the selected action',
                  options: [
                    {value: 'Yes', label: 'Yes'},
                    {value: 'No', label: 'No'},
                    {
                      value:
                        'No, because our tier 1 suppliers are producers, and have no suppliers of commodities [F only]',
                      label:
                        'No, because our tier 1 suppliers are producers, and have no suppliers of commodities [F only]'
                    },
                    {value: 'Unknown', label: 'Unknown'}
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.8 Provide details of any environmental smallholder engagement activity.',
            tooltip:
              'Identified risks may offer an opportunity for an organization to engage with local stakeholders to drive local economic development and/or environmental action. In many countries/areas, organizations are called to work with smallholders to source raw materials sustainably. This question captures data on the extent of an organization’s engagement with smallholders. This information allows data users to assess corporate action towards sustainable value chains.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q36_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q36_1_VALUE,
                  fieldLabel: 'Environmental issue covered',
                  options: [
                    {value: 'Timber products', label: 'Timber products'},
                    {value: 'Palm oil', label: 'Palm oil'},
                    {value: 'Cattle products', label: 'Cattle products'},
                    {value: 'Soy', label: 'Soy'},
                    {value: 'Rubber', label: 'Rubber'},
                    {value: 'Cocoa', label: 'Cocoa'},
                    {value: 'Coffee', label: 'Coffee'},
                    {
                      value: 'Other, please specify [FS only]',
                      label: 'Other, please specify [FS only]'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q36_2_VALUE,
                  fieldLabel:
                    'Type and details of smallholder engagement approach',
                  options: TYPE_AND_DETAILS_OF_ENGAGEMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q36_3_VALUE,
                  fieldLabel: 'Number of smallholders engaged',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q36_4_VALUE,
                  fieldLabel: 'Effect of engagement and measures of success',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.11.9 Provide details of any environmental engagement activity with other stakeholders in the value chain.',
            tooltip:
              'This question provides data users with transparency regarding organizations engagement processes with other value chain stakeholders. As several environmental dependencies, impacts, risks, and opportunities can occur outside direct operations, data users are interested in understanding how organizations are working with other stakeholders in their value chain to drive environmental action.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_2_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q28_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_1_VALUE,
                  fieldLabel: 'Environmental issue',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_2_VALUE,
                  fieldLabel: 'Type of stakeholder',
                  options: [
                    {
                      value: 'Customers [Not shown to FS]',
                      label: 'Customers [Not shown to FS]'
                    },
                    {
                      value: 'Investors and shareholders',
                      label: 'Investors and shareholders'
                    },
                    {
                      value: 'Other value chain stakeholder, please specify',
                      label: 'Other value chain stakeholder, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_3_VALUE,
                  fieldLabel: 'Type and details of engagement',
                  options: TYPE_AND_DETAILS_OF_ENGAGEMENT_EDUCATION_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_4_VALUE,
                  fieldLabel: '% of stakeholder type engaged',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_5_VALUE,
                  fieldLabel: '% stakeholder associated scope 3 emissions',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Climate change']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_6_VALUE,
                  fieldLabel:
                    'Rationale for engaging these stakeholders and scope of engagement',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q37_7_VALUE,
                  fieldLabel: 'Effect of engagement and measures of success',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.12 Indicate any mutually beneficial environmental initiatives you could collaborate on with specific CDP Supply Chain members.',
            tooltip:
              'Addressing environmental issues effectively oftentimes requires collective action. Through this question, your organization can propose ways it can work together with its requesting Supply Chain members to reduce environmental risks and/or to realize opportunities that would benefit both your organization and your customers. It can also be used to strengthen communication between you and your customers and help drive innovative new partnerships.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_2_VALUE,
                  fieldLabel: 'Environmental issues the initiative relates to',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_3_VALUE,
                  fieldLabel: 'Commodities the initiative relates to [F only]',
                  options: COMMODITY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_2_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Forests']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_4_VALUE,
                  fieldLabel: 'Initiative category and type',
                  options: INITIATIVE_CATEGORY_AND_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_5_VALUE,
                  fieldLabel: 'Details of initiative',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_6_VALUE,
                  fieldLabel: 'Expected benefits',
                  options: EXPECTED_BENEFITS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_7_VALUE,
                  fieldLabel: 'Estimated timeframe for realization of benefits',
                  options: [
                    {value: '0 - 1 year', label: '0 - 1 year'},
                    {value: '1 - 3 years', label: '1 - 3 years'},
                    {value: '3 - 5 years', label: '3 - 5 years'},
                    {value: '> 5 years', label: '> 5 years'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_8_VALUE,
                  fieldLabel:
                    'Are you able to estimate the lifetime CO2e and/or water savings of this initiative?',
                  options: [
                    {
                      value:
                        'Yes, both lifetime CO2e and lifetime water savings',
                      label:
                        'Yes, both lifetime CO2e and lifetime water savings'
                    },
                    {
                      value: 'Yes, lifetime CO2e savings only',
                      label: 'Yes, lifetime CO2e savings only'
                    },
                    {
                      value: 'Yes, lifetime water savings only',
                      label: 'Yes, lifetime water savings only'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_9_VALUE,
                  fieldLabel: 'Estimated lifetime CO2e savings',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_8_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, lifetime CO2e savings only',
                      'Yes, both lifetime CO2e and lifetime water savings'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_10_VALUE,
                  fieldLabel: 'Estimated lifetime water savings',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_8_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, lifetime CO2e savings only',
                      'Yes, both lifetime CO2e and lifetime water savings'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q38_11_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.13 Has your organization already implemented any mutually beneficial environmental initiatives due to CDP Supply Chain member engagement?',
            tooltip:
              'Effectively addressing environmental issues oftentimes requires collective action. This question allows organizations to indicate their commitment to collaborative environmental action through the implementation of initiatives.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_1_VALUE,
                  fieldLabel:
                    'Environmental initiatives implemented due to CDP Supply Chain member engagement',
                  options: PROCESS_PLACE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_2_VALUE,
                  fieldLabel:
                    'Primary reason for not implementing environmental initiatives',
                  options:
                    PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, and we do not plan to within the next two years',
                      'No, but we plan to within the next two years'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_3_VALUE,
                  fieldLabel:
                    'Explain why your organization has not implemented any environmental initiatives',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, and we do not plan to within the next two years',
                      'No, but we plan to within the next two years'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.13.1 Specify the CDP Supply Chain members that have prompted your implementation of mutually beneficial environmental initiatives and provide information on the initiatives.',
            tooltip:
              'Addressing environmental issues effectively oftentimes requires collective action. This question presents an opportunity to demonstrate the types of initiatives that you have implemented due to CDP Supply Chain member engagement and to detail how they have progressed and any mutual benefits that have been seen so far. Please note that this table is designed so that only the customers that you select in column 1 “Requesting member” will be able to see the data relevant to them. If you enter an answer without selecting a requesting member, your answer will not be viewable at all.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_1_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q39_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_2_VALUE,
                  fieldLabel: 'Environmental issues the initiative relates to',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_3_VALUE,
                  fieldLabel: 'Commodities the initiative relates to [F only]',
                  options: COMMODITY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_2_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Forests']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_4_VALUE,
                  fieldLabel: 'Initiative ID',
                  options: INITIATIVE_ID_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_5_VALUE,
                  fieldLabel: 'Initiative category and type',
                  options: INITIATIVE_CATEGORY_AND_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_6_VALUE,
                  fieldLabel: 'Details of initiative',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_7_VALUE,
                  fieldLabel: 'Expected benefits',
                  options: EXPECTED_BENEFITS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_8_VALUE,
                  fieldLabel:
                    'Are you able to provide figures for emissions savings or water savings in the reporting year? ',
                  options: [
                    {
                      value: 'Yes, emissions savings and water savings',
                      label: 'Yes, emissions savings and water savings'
                    },
                    {
                      value: 'Yes, emissions savings only',
                      label: 'Yes, emissions savings only'
                    },
                    {
                      value: 'Yes, water savings only',
                      label: 'Yes, water savings only'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_9_VALUE,
                  fieldLabel:
                    'Estimated savings in the reporting year in metric tons of CO2e',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_8_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, emissions savings and water savings',
                      'Yes, emissions savings only'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_10_VALUE,
                  fieldLabel:
                    'Estimated water savings in the reporting year in megaliters',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_8_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, emissions savings and water savings',
                      'Yes, emissions savings only'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_11_VALUE,
                  fieldLabel:
                    'Please explain how success for this initiative is measured',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q40_12_VALUE,
                  fieldLabel:
                    'Would you be happy for CDP Supply Chain members to highlight this work in their external communication?',
                  options: ['Yes', 'No'],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.14 Do your external asset managers have to meet environmental requirements as part of your organization’s selection process and engagement?',
            tooltip:
              'For asset owners and asset managers working with external funds (third parties), the external asset managers have a significant effect on investment strategies and objectives. Including environmental requirements into the selection of and engagement with external asset managers ensures that these investment strategies and objectives are aligned with the organization’s business strategy.',
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_1_VALUE,
                  fieldLabel:
                    'External asset managers have to meet specific environmental requirements as part of the selection process and engagement',
                  options: [
                    {value: 'Yes', label: 'Yes'},
                    {
                      value:
                        'No, but we plan to include environmental requirements in the next two years',
                      label:
                        'No, but we plan to include environmental requirements in the next two years'
                    },
                    {
                      value:
                        'No, and we do not plan to include environmental requirements in the next two years',
                      label:
                        'No, and we do not plan to include environmental requirements in the next two years'
                    },
                    {
                      value:
                        'Not applicable, because we do not have externally managed assets',
                      label:
                        'Not applicable, because we do not have externally managed assets'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_2_VALUE,
                  fieldLabel:
                    'Policy in place for addressing external asset manager noncompliance',
                  options: [
                    {
                      value:
                        'Yes, we have a policy in place for addressing non-compliance',
                      label:
                        'Yes, we have a policy in place for addressing non-compliance'
                    },
                    {
                      value:
                        'No, we do not have a policy in place for addressing non-compliance',
                      label:
                        'No, we do not have a policy in place for addressing non-compliance'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_1_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_3_VALUE,
                  fieldLabel:
                    'Primary reason for not including environmental requirements in selection process and engagement with external asset managers',
                  options:
                    PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_4_VALUE,
                  fieldLabel:
                    'Explain why environmental requirements are not included in selection process and engagement with external asset managers',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.14.1 Provide details of the environmental requirements that external asset managers have to meet as',
            tooltip:
              'For asset owners and managers working with external funds (third parties), the external asset managers have a significant effect on investment strategies and objectives. Including environmental requirements into the selection of and engagement with external asset managers ensures that these investment strategies and objectives are aligned with the organization’s business strategy.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q42_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_1_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q41_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q42_1_VALUE,
                  fieldLabel:
                    'Environmental issues covered by the requirement  ',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q42_2_VALUE,
                  fieldLabel: 'Coverage',
                  options: [
                    {
                      value: 'All assets managed externally',
                      label: 'All assets managed externally'
                    },
                    {
                      value: 'Majority of assets managed externally',
                      label: 'Majority of assets managed externally'
                    },
                    {
                      value: 'Minority of assets managed externally',
                      label: 'Minority of assets managed externally'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q42_3_VALUE,
                  fieldLabel:
                    'Environmental requirement that external asset managers have to meet',
                  options: [
                    {
                      value: 'Committing to net-zero emissions by 2050',
                      label: 'Committing to net-zero emissions by 2050'
                    },
                    {
                      value:
                        'Having a transition plan, which is aligned with a 1.5°C world',
                      label:
                        'Having a transition plan, which is aligned with a 1.5°C world'
                    },
                    {
                      value:
                        'Membership/signatory of a sustainable finance initiative(s) and/or alliance(s)',
                      label:
                        'Membership/signatory of a sustainable finance initiative(s) and/or alliance(s)'
                    },
                    {
                      value:
                        'Offering environmentally sustainable products and services',
                      label:
                        'Offering environmentally sustainable products and services'
                    },
                    {
                      value: 'Setting environmental target(s)',
                      label: 'Setting environmental target(s)'
                    },
                    {
                      value: 'Setting science-based target(s)',
                      label: 'Setting science-based target(s)'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q42_4_VALUE,
                  fieldLabel:
                    'Mechanisms used to include environmental requirement in external asset manager selection .',
                  options: [
                    {
                      value:
                        'Include environmental requirements in requests for proposals',
                      label:
                        'Include environmental requirements in requests for proposals'
                    },
                    {
                      value:
                        'Preference for investment managers with an offering of funds resilient to environmental issues',
                      label:
                        'Preference for investment managers with an offering of funds resilient to environmental issues'
                    },
                    {
                      value:
                        'Include environmental requirements in investment mandates',
                      label:
                        'Include environmental requirements in investment mandates'
                    },
                    {
                      value:
                        'Include environmental requirements in performance indicators and incentive structures',
                      label:
                        'Include environmental requirements in performance indicators and incentive structures'
                    },
                    {
                      value:
                        'Review investment manager’s environmental performance (e.g., active ownership, proxy voting records, under-weighting in high impact activities)',
                      label:
                        'Review investment manager’s environmental performance (e.g., active ownership, proxy voting records, under-weighting in high impact activities)'
                    },
                    {
                      value:
                        'Review investment manager’s environmental policies',
                      label:
                        'Review investment manager’s environmental policies'
                    },
                    {
                      value:
                        'Publish requirements of external investment managers in relation to environmental issues',
                      label:
                        'Publish requirements of external investment managers in relation to environmental issues'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q42_5_VALUE,
                  fieldLabel:
                    'Response to external asset manager noncompliance with environmental requirement',
                  options: [
                    {value: 'Exclude', label: 'Exclude'},
                    {value: 'No response', label: 'No response'},
                    {value: 'Suspend and engage', label: 'Suspend and engage'},
                    {value: 'Retain and engage', label: 'Retain and engage'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q42_6_VALUE,
                  fieldLabel:
                    '% of noncompliant external asset managers engaged',
                  options: PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.15 Does your organization exercise voting rights as a shareholder on environmental issues?',
            tooltip: `Active ownership is a key tool for positively affecting the real economy because
divestment alone leaves investors without a voice to promote sustainable practices.
Alongside their investee engagement activities, investors can influence their investee companies on environmental issues by exercising their voting rights. Data users are interested in understanding how aligned shareholders’ voting decisions across the investment portfolio are with the overall environmental strategy and how they support environmental shareholder resolutions.`,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_1_VALUE,
                  fieldLabel:
                    'Exercise voting rights as a shareholder on environmental issues',
                  options: [
                    {value: 'Yes', label: 'Yes'},
                    {
                      value: 'No, but we plan to in the next two years',
                      label: 'No, but we plan to in the next two years'
                    },
                    {
                      value: 'No, and we do not plan to in the next two years',
                      label: 'No, and we do not plan to in the next two years'
                    },
                    {
                      value:
                        'No, as we do not have shareholder voting rights in any of our investments',
                      label:
                        'No, as we do not have shareholder voting rights in any of our investments'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_2_VALUE,
                  fieldLabel:
                    'Primary reason for not exercising voting rights as a shareholder on environmental issues',
                  options:
                    PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_3_VALUE,
                  fieldLabel:
                    'Explain why you do not exercise voting rights on environmental issues',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, as we do not have shareholder voting rights in any of our investments'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '5.15.1 Provide details of your shareholder voting record on environmental issues.',
            tooltip:
              'Active ownership is a key tool for positively affecting the real economy because divestment alone leaves investors without a voice to promote sustainable practices. Alongside their investee engagement activities, investors can influence their investee companies on environmental issues, by exercising their voting rights. Data users are interested in understanding how aligned shareholders’ voting decisions across the investment portfolio are with the overall environmental strategy and how they support environmental shareholder resolutions. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_VALUE,
            dependsOn:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_1_VALUE,
            showWhen: ['Yes'],
            releatedTableKey:
              CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q43_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_1_VALUE,
                  fieldLabel:
                    'Method used to exercise your voting rights as a shareholder',
                  options: [
                    {
                      value: 'Exercise voting rights directly',
                      label: 'Exercise voting rights directly'
                    },
                    {
                      value:
                        'Exercise voting rights through an external service provider',
                      label:
                        'Exercise voting rights through an external service provider'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_2_VALUE,
                  fieldLabel:
                    'How do you ensure your shareholder voting rights are exercised in line with your overall strategy or transition plan?.',
                  options: [
                    {value: 'Vote tracking', label: 'Vote tracking'},
                    {
                      value:
                        'Publish requirements of external service providers in relation to environmental issues',
                      label:
                        'Publish requirements of external service providers in relation to environmental issues'
                    },
                    {
                      value:
                        'Review external service provider’s environmental policies',
                      label:
                        'Review external service provider’s environmental policies'
                    },
                    {
                      value:
                        'Review external service provider’s environmental performance (e.g. active ownership, proxy voting records)',
                      label:
                        'Review external service provider’s environmental performance (e.g. active ownership, proxy voting records)'
                    },
                    {
                      value:
                        'Include environmental requirements in requests for proposals',
                      label:
                        'Include environmental requirements in requests for proposals'
                    },
                    {
                      value:
                        'Include environmental requirements in service provider mandates',
                      label:
                        'Include environmental requirements in service provider mandates'
                    },
                    {
                      value:
                        'Include environmental requirements in performance indicators and incentive structures',
                      label:
                        'Include environmental requirements in performance indicators and incentive structures'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Exercise voting rights through an external service provider'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_3_VALUE,
                  fieldLabel: '% of voting rights exercised',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_4_VALUE,
                  fieldLabel: '% of voting which is publicly available',
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_5_VALUE,
                  fieldLabel:
                    'Environmental issues covered in shareholder voting',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_6_VALUE,
                  fieldLabel:
                    'Global environmental commitments that your shareholder voting is aligned with .',
                  options: [
                    {
                      value: 'Aligned with the Paris Agreement [CC only]',
                      label: 'Aligned with the Paris Agreement [CC only]'
                    },
                    {
                      value:
                        'Aligned with the Kunming-Montreal Global Biodiversity Framework [F, W]',
                      label:
                        'Aligned with the Kunming-Montreal Global Biodiversity Framework [F, W]'
                    },
                    {
                      value:
                        'Aligned with Sustainable Development Goal 6 on Clean Water and Sanitation [W only]',
                      label:
                        'Aligned with Sustainable Development Goal 6 on Clean Water and Sanitation [W only]'
                    },
                    {
                      value:
                        'Aligned with another global environmental commitment, please specify',
                      label:
                        'Aligned with another global environmental commitment, please specify'
                    },
                    {
                      value:
                        'Our shareholder voting is not aligned with any environmental commitment',
                      label:
                        'Our shareholder voting is not aligned with any environmental commitment'
                    },
                    {value: 'Not assessed', label: 'Not assessed'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_STRATEGY_FIELD_NAMES.CORPORATE_STRATEGY_Q44_7_VALUE,
                  fieldLabel: 'Issues supported in shareholder resolutions',
                  options: ISSUES_SUPPORTED_IN_SHAREHOLDER_RESOLUTIONS_OPTIONS,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];
